// export default function registerScrollToActive(Alpine) {
//   Alpine.data("scrollToActive", (initialTab = "") => ({
//     activeTab: initialTab,

//     init() {
//       this.scrollToActive();

//       this.$watch("activeTab", () => {
//         this.scrollToActive();
//       });
//     },

//     scrollToActive() {
//       this.$nextTick(() => {
//         const activeEl = this.$el.querySelector(".active-tab");

//         if (!activeEl) return;

//         activeEl.scrollIntoView({
//           behavior: "smooth",
//           block: "center", // Changed from "nearest"
//           inline: "center", // Changed from "nearest"
//         });

//         // Optional: add extra offset after scroll
//         // const navContainer = this.$el;
//         // navContainer.scrollTop -= 60; // Adjust number for desired padding
//       });
//     },
//   }));
// }

export default function registerScrollToActive(Alpine) {
  Alpine.data("scrollToActive", (keyName = "activeTab") => ({
    keyToWatch: keyName,
    currentValue: window[keyName] || "",

    init() {
      this.scrollToActive();

      // Listen for any custom event with the key name
      window.addEventListener(`${this.keyToWatch}Changed`, (e) => {
        this.currentValue = e.detail;
      });

      this.$watch("currentValue", () => {
        this.scrollToActive();
      });
    },

    scrollToActive() {
      this.$nextTick(() => {
        const activeEl = this.$el.querySelector(".active-tab");

        if (!activeEl) return;

        activeEl.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });

        // Optional: add extra offset after scroll
        // const navContainer = this.$el;
        // navContainer.scrollTop -= 60; // Adjust number for desired padding
      });
    },
  }));
}
